import React, { useState } from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { TransparentErrorBoundary } from '@confluence/error-boundary/entry-points/TransparentErrorBoundary';

import { LazyEditorPageCoverPicture } from '../lazyLoadables';
import type { EditorPageCoverPictureEntryComponentProps } from '../pageCoverPictureTypes';
import { CoverPictureStateContainer } from '../CoverPictureStateContainer';

const EditorPageCoverPictureEntryComponent = ({
	contentId,
	isPublishingContent,
	contentType,
	userOffline,
	coverPictureState,
	isUnpublishedDraft,
	floatingToolbarButtonStyle,
	isFixedWidthImageOption,
	width,
	dynamicCoverImageHeight,
	isReadOnly,
	hasCoverPicture,
	aiSuggestedUnsplashImages,
	isUnsplash,
	aiHeaderImageStatus,
	aiHeaderImageFileId,
	generateAIHeaderImage,
	setAIHeaderImageStatus,
}: EditorPageCoverPictureEntryComponentProps) => {
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	if (hasCoverPicture) {
		return (
			<div
				data-testid="has-cover-picture-component"
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				style={{
					position: isFixedWidthImageOption ? 'relative' : 'absolute',
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
					left: '0px',
					// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
					right: '0px',
				}}
			>
				{/*
        // @ts-ignore */}
				<LazyEditorPageCoverPicture
					contentId={contentId}
					isPublishingContent={isPublishingContent}
					contentType={contentType}
					userOffline={userOffline}
					hasCoverPicture={hasCoverPicture}
					coverPictureState={coverPictureState}
					isUnpublishedDraft={isUnpublishedDraft}
					floatingToolbarButtonStyle={floatingToolbarButtonStyle}
					width={width}
					dynamicCoverImageHeight={dynamicCoverImageHeight}
					isReadOnly={isReadOnly}
					aiSuggestedUnsplashImages={aiSuggestedUnsplashImages}
					isUnsplash={isUnsplash}
					isFixedWidthImageOption={isFixedWidthImageOption}
					aiHeaderImageStatus={aiHeaderImageStatus}
					aiHeaderImageFileId={aiHeaderImageFileId}
					generateAIHeaderImage={generateAIHeaderImage}
					setAIHeaderImageStatus={setAIHeaderImageStatus}
				/>
			</div>
		);
	} else if (isModalOpen && !hasCoverPicture) {
		// TODO: remove the code here since isModalOpen is no longer needed: https://product-fabric.atlassian.net/browse/PGXT-9335
		return (
			<div data-testid="no-cover-picture-component-modal-open">
				{/*
        // @ts-ignore */}
				<LazyEditorPageCoverPicture
					contentId={contentId}
					isPublishingContent={isPublishingContent}
					contentType={contentType}
					userOffline={userOffline}
					setIsModalOpen={setIsModalOpen}
					isModalOpen={isModalOpen}
					hasCoverPicture={hasCoverPicture}
					coverPictureState={coverPictureState}
					isUnpublishedDraft={isUnpublishedDraft}
					floatingToolbarButtonStyle={floatingToolbarButtonStyle}
					width={width}
					dynamicCoverImageHeight={dynamicCoverImageHeight}
					isReadOnly={isReadOnly}
					aiSuggestedUnsplashImages={aiSuggestedUnsplashImages}
					aiHeaderImageStatus={aiHeaderImageStatus}
					aiHeaderImageFileId={aiHeaderImageFileId}
					generateAIHeaderImage={generateAIHeaderImage}
					setAIHeaderImageStatus={setAIHeaderImageStatus}
				/>
			</div>
		);
	} else {
		// no cover picture and modal isn't open
		return (
			<div data-testid="no-cover-picture-component">
				{/*
        // @ts-ignore */}
				<LazyEditorPageCoverPicture
					contentId={contentId}
					isPublishingContent={isPublishingContent}
					contentType={contentType}
					userOffline={userOffline}
					setIsModalOpen={setIsModalOpen}
					isModalOpen={isModalOpen}
					hasCoverPicture={hasCoverPicture}
					coverPictureState={coverPictureState}
					isUnpublishedDraft={isUnpublishedDraft}
					floatingToolbarButtonStyle={floatingToolbarButtonStyle}
					width={width}
					dynamicCoverImageHeight={dynamicCoverImageHeight}
					isReadOnly={isReadOnly}
					aiSuggestedUnsplashImages={aiSuggestedUnsplashImages}
					aiHeaderImageStatus={aiHeaderImageStatus}
					aiHeaderImageFileId={aiHeaderImageFileId}
					generateAIHeaderImage={generateAIHeaderImage}
					setAIHeaderImageStatus={setAIHeaderImageStatus}
				/>
			</div>
		);
	}
};

export const EditorPageCoverPictureEntry = (props) => (
	<TransparentErrorBoundary attribution={Attribution.PAGE_EXTENSIONS}>
		<Subscribe to={[CoverPictureStateContainer]}>
			{(coverPictureState: CoverPictureStateContainer) => (
				<EditorPageCoverPictureEntryComponent {...props} coverPictureState={coverPictureState} />
			)}
		</Subscribe>
	</TransparentErrorBoundary>
);
